import DefaultLayout from "../components/layout/DefaultLayout";
function OwnerHome() {
  const body = () => {
    return (
      <div>
        <section className="slice sct-color-1" id="scrollToSection">
          <div className="container">
            <div className="section-title section-title--style-1 text-center mb-5">
              <span className="section-title-delimiter clearfix d-none"></span>
            </div>
            <span className="clearfix"></span>

            <div className="fluid-paragraph fluid-paragraph-sm c-gray-light strong-300 text-center">
              <h1>Owner title</h1>
            </div>

            <span className="space-xs-md"></span>
          </div>
        </section>
      </div>
    );
  };
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default OwnerHome;
